import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Layout } from './components/Layout';
import { ThemeProvider } from './components/theme';
import { Toaster, TooltipProvider } from './components/ui/misc';
import { Dashboard } from './pages/Dashboard';
import { ContentList } from './pages/ContentList';
import { ContentCreate } from './pages/ContentCreate';
import { ContentEdit } from './pages/ContentEdit';
import { LoginPage } from './pages/LoginPage';

function App() {
  return (
    <ThemeProvider>
      <TooltipProvider delayDuration={300}>
        <BrowserRouter>
          <Authenticator.Provider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/*"
                element={
                  <Authenticator>
                    {({ signOut, user }) => (
                      <Layout user={user} onSignOut={signOut}>
                        <Routes>
                          <Route path="/" element={<Dashboard />} />
                          <Route path="/content" element={<ContentList />} />
                          <Route path="/content/create" element={<ContentCreate />} />
                          <Route path="/content/:cardId" element={<ContentEdit />} />
                          <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                      </Layout>
                    )}
                  </Authenticator>
                }
              />
            </Routes>
          </Authenticator.Provider>
        </BrowserRouter>
        <Toaster />
      </TooltipProvider>
    </ThemeProvider>
  );
}

export default App;
